import Repository from "./repository"

export default {
    /**
     * ログイン済チェック処理
     * @returns response
     */
    check() {
        return Repository.get("/api/c201-login/check")
    },

    /**
     * ログイン処理
     * @params パラメーター
     * @returns response
     */
    login(params) {
        return Repository.post("/api/c201-login/login", params)
    },

    /**
     * ログアウト処理
     * @returns response
     */
    logout() {
        return Repository.get('/api/c201-login/logout')
    },
}